<template>
  <div>
    <a-tag v-if="displayType === 'tag'" :color="color">{{ $t(`ticket_status.${status}`) }}</a-tag>
    <custom-tag v-else :color="color" :text="$t(`ticket_status.${status}`)" :font-size="fontSize"></custom-tag>
  </div>

</template>

<script>
import CustomTag from './CustomTag.vue'

export default {
  name: 'TicketStatusTag',
  components: {
    CustomTag
  },
  props: {
    status: {
      type: String,
      required: true
    },
    displayType: {
      type: String,
      default: 'tag'
    },
    fontSize: {
      type: Number,
      default: 12
    }
  },
  computed: {
    color () {
      switch (this.status) {
        case 'pending':
          return '#ff5b52'
        case 'processing':
          return '#69c66f'
        case 'processed':
          return '#bababa'
        default:
          return '#bababa'
      }
    }
  }
}
</script>
